import { motion } from 'framer-motion';

interface FillProgressBarProps {
  filled: number;
  total: number;
  deadlineMs: number;
  currentTimeMs: number;
  label?: string;
}

function getBarColor(filled: number, total: number, deadlineMs: number, currentTimeMs: number): string {
  if (filled >= total) return 'hsl(142, 70%, 45%)'; // green — all filled
  const msRemaining = deadlineMs - currentTimeMs;
  const h24 = 24 * 60 * 60 * 1000;
  if (msRemaining < h24) return 'hsl(0, 85%, 55%)'; // red — less than 24h
  return 'hsl(24, 95%, 53%)'; // orange — more than 24h
}

export function FillProgressBar({ filled, total, deadlineMs, currentTimeMs, label }: FillProgressBarProps) {
  const pct = total > 0 ? (filled / total) * 100 : 0;
  const barColor = getBarColor(filled, total, deadlineMs, currentTimeMs);
  const allFilled = filled >= total;

  return (
    <div className="space-y-1.5">
      <div className="h-2 rounded-full bg-[hsl(0,0%,15%)] overflow-hidden">
        <motion.div
          className="h-full rounded-full"
          style={{ backgroundColor: barColor }}
          initial={{ width: 0 }}
          animate={{ width: `${pct}%` }}
          transition={{ type: 'spring', stiffness: 120, damping: 20 }}
        />
      </div>
      <p className="text-sm text-muted-foreground" dir="rtl">
        <span style={{ color: allFilled ? 'hsl(142, 70%, 45%)' : 'hsl(24, 95%, 53%)' }} className="font-semibold">
          {filled}/{total}
        </span>
        {' '}{label || 'מילאו בראקט'}
      </p>
    </div>
  );
}

export default FillProgressBar;
